export default "__VITE_ASSET__B5QUQyz9__"